
const blockAnchorLinksBar = () => {
    if($('.block-anchor-links-bar')) {
        $('.block-breadcrumbs').addClass('has-anchor');
    }

    $('.anchor-links-bar-link').on('click', function() {
        $('.anchor-links-bar-link').removeClass('active');
        $(this).addClass('active');
    });

    $('.mobile-nav-icon').on('click', function() {
        $('.anchor-links-bar').toggleClass('open');
    })
};

export default blockAnchorLinksBar;